import React from 'react'
import Cookies from 'js-cookie'
import { AddToTrolley } from '@sainsburys-tech/fable-extended'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import { connect } from 'react-redux'
import { useAddToTrolleyContext } from '../../providers/AddToTrolleyContext/AddToTrolleyContext'

const FableAddToTrolleyDrawer = ({ updateHeaderTrolleyCount, brand }) => {
  const { addToTrolleyState, setAddToTrolleyState } = useAddToTrolleyContext()

  const errorCallbackFunction = () => {
    if (window?.newrelic) {
      const error = new Error('Error with Fable Add To Trolley component')
      window?.newrelic?.noticeError(error)
    }
  }

  const onAddToTrolleyRequestSuccess = () => {
    const { quantity, bundleItems } = addToTrolleyState?.modalProps || {}
    const payload = {
      quantity,
      bundleItems
    }
    updateHeaderTrolleyCount(payload)
  }

  const BRAND = process.env.BRAND || 'ARGOS'
  const cookieValue = Cookies.get('PDP_Test_Group_1')
  const bundleType = cookieValue === '2' && BRAND === 'TU' ? 'bundles_c' : 'bundles'
  const isArgosVariant = cookieValue === '2' && BRAND === 'ARGOS'

  if (addToTrolleyState?.show) {
    return (
      <ErrorBoundary callbackFunction={errorCallbackFunction}>
        <div id='fable-extended-att'>
          <AddToTrolley
            {...addToTrolleyState?.modalProps}
            onAddToTrolleyRequestSuccess={onAddToTrolleyRequestSuccess}
            onClose={() => setAddToTrolleyState({ show: false })}
            brand={brand}
            bundleType={bundleType}
            hideExitButtonOnProtection={isArgosVariant}
            showPreProtectionPage={false}
          />
        </div>
      </ErrorBoundary>
    )
  }
  return null
}

// Action handled by the Bolt AddToTrolley reducer to update the trolley count in the header
const completeTrolleyRequest = payload => ({
  type: 'COMPLETE_TROLLEY_REQUEST',
  payload
})

const mapDispatchToProps = dispatch => {
  const props = {
    updateHeaderTrolleyCount: payload => dispatch(completeTrolleyRequest(payload))
  }
  return props
}

export default connect(null, mapDispatchToProps)(FableAddToTrolleyDrawer)
